import { AiMedicalDocumentItem, AppointmentType, DocumentProcessingStatus } from '../models/document.interface';
import { ContextSearchDocumentItem } from '../models/search.interface';

export function transformContextDocumentToAiDocument(contextDoc: ContextSearchDocumentItem): AiMedicalDocumentItem {
  return {
    id: contextDoc.id,
    userId: null,
    healthManagerTags: contextDoc.tags,
    fileLink: contextDoc.link,
    fileSize: null,
    fileName: contextDoc.name,
    type: mapContextTypeToAppointmentType(contextDoc.type),
    description: contextDoc.description,
    createdAt: contextDoc.documentDate,
    updatedAt: contextDoc.documentDate,
    processingStatus: DocumentProcessingStatus.Done,
    uploadedBy: null,
    isEditable: false,
    isDraft: false,
    documentTitle: contextDoc.name,
    documentDate: contextDoc.documentDate,
    executedServices: null,
    plannedServices: null,
    plannedMedications: null,
    gatheredObservations: null,
    recommendations: null,
    notes: null,
    diagnoses: null,
    keywords: null,
    documentClass: null,
    isMigration: false,
    fileHash: null,
  };
}

function mapContextTypeToAppointmentType(type: string): AppointmentType {
  switch (type) {
    case 'Appointment':
      return AppointmentType.Appointment;
    case 'PersonalDoctorAppointment':
      return AppointmentType.PersonalDoctorAppointment;
    // TODO: uncomment when Vaccination will added as one of possible medical document
    // case 'Drugs':
    //   return AppointmentType.Drugs;
    case 'LaboratoryService':
      return AppointmentType.LaboratoryService;
    case 'InstrumentalDiagnostic':
      return AppointmentType.InstrumentalDiagnostic;
    case 'Other':
    default:
      return AppointmentType.Other;
  }
}
